'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _darken = require('../internal/darken');

var _darken2 = _interopRequireDefault(_darken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    borderRadius: '4px',
    boxSizing: 'border-box',
    fontSize: '16px',
    fontWeight: 'inherit',
    lineHeight: '20px',
    padding: '12px 8px',
    position: 'relative',
    minWidth: '272px',
    maxWidth: '496px'
  },
  icon: {
    height: '24px',
    position: 'absolute',
    top: '50%',
    left: '8px',
    transform: 'translateY(-50%)',
    width: '24px'
  },
  text: {
    margin: '0',
    paddingLeft: '32px',

    '&:first-letter': {
      textTransform: 'capitalize'
    }
  },
  button: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '4px'
  },
  success: {
    backgroundColor: _colors2.default.alert.success,
    border: '1px solid ' + (0, _darken2.default)(_colors2.default.alert.success, 0.1),
    color: (0, _darken2.default)(_colors2.default.alert.success, 0.65)
  },
  error: {
    backgroundColor: _colors2.default.alert.error,
    border: '1px solid ' + (0, _darken2.default)(_colors2.default.alert.error, 0.1),
    color: (0, _darken2.default)(_colors2.default.alert.error, 0.65)
  },
  warning: {
    backgroundColor: _colors2.default.alert.warning,
    border: '1px solid ' + (0, _darken2.default)(_colors2.default.alert.warning, 0.1),
    color: (0, _darken2.default)(_colors2.default.alert.warning, 0.65)
  },
  info: {
    backgroundColor: _colors2.default.alert.info,
    border: '1px solid ' + (0, _darken2.default)(_colors2.default.alert.info, 0.1),
    color: (0, _darken2.default)(_colors2.default.alert.info, 0.65)
  }
};
module.exports = exports.default;